import { HttpInterceptorFn } from '@angular/common/http';
import { inject } from '@angular/core';
import { LanguageService } from '../services/Language/lang.service';

export const langInterceptor: HttpInterceptorFn = (req, next) => {
  const lang = inject(LanguageService).getLang();
  return next(req.clone({ setHeaders: { 'accept-language': lang }}));
};
